module.exports = __webpack_public_path__ + "img/Миофасциальные боли шеи и спины.a06e6f7a.jpg";